module.exports = __webpack_public_path__ + "static/media/098-guatemala.7e0ae1d1.svg";